import {useEffect, useState} from 'react';

// Returns `value`, but only after it has stopped changing for `delay` ms.
// Use for debouncing search inputs before firing an API call.
const useDebounce = (value, delay = 400) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
